<template>

  <header class="api-header">
    <div class="header-img-container" :style="{'width': $screen.breakpoint !== 'lg' ? '30%' : ''}">
      <img :src="logoUrl" alt="Breezi-Pro" @click="$router.push({path: '/'})" :style="{'width': $screen.breakpoint == 'lg' ? '' : '110px', 'height': $screen.breakpoint == 'lg' ? '' : 'auto'}">
    </div>
    <div class="api-header-items" :style="{'width': $screen.breakpoint !== 'lg' ? '55%' : '', 'justify-content': $screen.breakpoint !== 'lg' ? 'flex-start' : ''}">
      <h2 v-if="$screen.breakpoint == 'lg'">Commercial API Documentation<span style="color:rgb(0,153,191);"> : {{sectionTitle}}</span></h2>
      <h5 v-else style="color:white;">Commercial API Documentation: <br/> <span style="color:rgb(0,153,191);">{{sectionTitle}}</span></h5>
    </div>
  </header>

</template>

<script type="text/javascript">

export default {
  data(){
    return {
      logoUrl: 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/pro-box.png'
    }
  },
  computed: {
    sectionTitle: function(){
      return this.$store.getters.getActiveSection().title
    }
  }
}

</script>

<style>

.api-header {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid rgb(0, 153, 191);
  height: 85px;
  background: rgba(0, 0, 0, 0.55);
}

.header-img-container {
  width: 17.5%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.api-header img {
  height: 50px;
  padding: 3px;
  cursor: pointer;
}

.api-header-items {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Comfortaa, sans-serif;
  margin-right: 40px;
}

.api-header-items h2 {
  font-weight: 400;
  color: white;
}

 .api-header-items h5 {
   text-align: right;
 }

</style>



// WEBPACK FOOTER //
// src/components/api/Header.vue